<ng-container *ngFor="let entry of entryList; last as isLast">
  <a [href]="entry.url" [attr.aria-label]="entry.ariaLabel">{{ entry.displayName }}</a>
  <span *ngIf="!isLast" class="divider">{{ listDivider }}</span>
</ng-container>
